import ButtonCellActionComponent from "./ButtonCellAction";
import {
    Subtitle,
    Value,
    BottomAddon,
} from "./components/Base/ButtonCellActionBase";
import Label from "./components/Label/ButtonCellActionLabel";
import LeftIcon from "./components/LeftIcon/ButtonCellActionLeftIcon";

export interface IButtonCellActionExtensions {
    Label: typeof Label;
    Subtitle: typeof Subtitle;
    Value: typeof Value;
    LeftIcon: typeof LeftIcon;
    BottomAddon: typeof BottomAddon;
}

export const ButtonCellAction: typeof ButtonCellActionComponent &
    IButtonCellActionExtensions = Object.assign(ButtonCellActionComponent, {
    Label,
    Subtitle,
    Value,
    LeftIcon,
    BottomAddon,
});

export type { ButtonCellActionProps } from "./types";
export * from "./presets";
